const thdSearch = require('thd.search');
const searchCore = require('header.search.core');
const typeAhead = require('typeAheadV2');
const $ = require('jquery');

const config = {
  searchBoxButton: '.SearchBox__button',
  searchBoxCancel: '.SearchBox__cancel',
  searchIcon: '#icon-SearchIcon',
  searchBoxInput: '.SearchBox__input',
  searchBoxCover: '.SearchBox__cover',
};

class Search {
  init() {
    $('form#headerSearchForm').attr('onsubmit', '');
    const $typeAheadInput = $('#headerSearch');
    const $typeAheadContainer = $('#typeAheadContainer');
    const $historyContainer = $('#searchHistory');
    // if user is already focused on search then activate searchbox
    searchCore.checkSearchFocus();

    // Set the input field and container to populate
    typeAhead.initialize($typeAheadInput, {
      container: $typeAheadContainer,
      historyContainer: $historyContainer,
    });

    if (typeof window.DIGITAL_EMITTER !== 'undefined') {
      window.DIGITAL_EMITTER.trigger('typeaheadv2');
    }

    // Initialize the default search handler JS
    thdSearch.init();

    $(document)
      .on('click touchend', config.searchBoxCover, searchCore.openSearch)
      .on('click touchend', config.searchBoxInput, searchCore.openSearch)
      .on('focus', config.searchBoxButton, searchCore.openSearch)
      .on('click touchend', config.searchIcon, searchCore.openSearch)
      .on('blur', config.searchBoxButton, searchCore.closeSearch)
      .on(
        'click touchend',
        config.searchBoxCancel,
        searchCore.clearSearchField,
      );
  }
}

module.exports = new Search();
